import axios from "functions/axios";

export const CountriesReportAPI = () =>
  axios.get("admin/report/countries/").then((res) => res.data);

export const ApplicationsReportAPI = () =>
  axios.get("admin/report/applications/").then((res) => res.data);

export const DiffrentReportAPI = () => axios.get("admin/report/diffrent/").then((res) => res.data);

export const GetReportChart = () =>
  axios
    .get(
      "admin/report/barchart/?date=month&faculty=School of Architecture and Environmental Design/"
    )
    .then((res) => res.data);

export const GetAverageData = () =>
  axios.get("admin/report/averagetimeline/?date=all").then((res) => res.data);
